import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import {
  answeredListSelector,
  selectUpcomingList,
} from '../../redux/surveys/selectors';
import {
  targetUserIdSelector,
  targetUserSelector,
} from '../../redux/context/selectors';
import { actions as getUserActions } from '../../redux/profiles/get-user';
import {
  actions as upcomingSurveysActions,
  paginatedActions as upcomingSurveysPaginatedActions,
} from '../../redux/surveys/upcoming';
import { actions as contextActions } from '../../redux/context';
import { actions as answeredSurveysActions } from '../../redux/surveys/answered';
import { actions as getAccessLevels } from '../../redux/profiles/getAccessLevels';
import { selectIsAccessLeverProvider } from '../../redux/profiles/selectors';
import styles from './index.styl';

const mapStateToProps = state => ({
  answeredList: answeredListSelector(state),
  upcomingList: selectUpcomingList(state),
  profileData: targetUserSelector(state),
  targetUserId: targetUserIdSelector(state),
  isProvider: selectIsAccessLeverProvider(state),
});

const mapDispatchToProps = {
  getUser: getUserActions.send,
  fetchUpcomingSurveys: upcomingSurveysActions.send,
  setTargetUserId: contextActions.setTargetUserId,
  fetchAnsweredSurveys: answeredSurveysActions.send,
  loadNextUpcomingRequests: upcomingSurveysPaginatedActions.loadNextRequests,
  getAccessLevels: getAccessLevels.send,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  CSSModules(styles, { allowMultiple: true }),
);



// WEBPACK FOOTER //
// ./src/components/Surveys/enhance.js